<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-layout-reuse">
  <!--
      This placeholder is:
      - Using the `sc-placeholder` attribute to avoid rendering a wrapping tag of its own, so that Bootstrap's columns will work
          (.row > sc-placeholder > .col-sm will not layout with flexbox, but .row > .col-sm will)
      - Using templating to enable customizing the markup for each component within. In this case, it's placing each component
        in its own column of a flexbox layout - giving an n-up columnar layout. The component itself does not need to know that
        it's living in a columnar layout.
    -->
  <div
    class="row"
    sc-placeholder
    name="jss-reuse-example"
    [rendering]="rendering"
  >
    <!--
        Customized component rendering
        You can customize the rendering of each component in this placeholder using the renderEach template.
        This technique is useful for things like flexible column layouts (like this one), or to wrap each component
        in <li>, or otherwise alter the component rendering from outside the component itself.

        If you need to know the index of the rendering, you can add 'let-index="index"' to the ng-template
        Remove the template entirely to use default component rendering (no wrappers, etc)
      -->
    <ng-template renderEach let-rendering="rendering">
      <div class="col-sm">
        <!-- renders a single component like a placeholder does, based on the component data -->
        <sc-render-component [rendering]="rendering"></sc-render-component>
      </div>
    </ng-template>
    <!--
        Customized empty placeholder rendering
        When using renderEach, in some situations an _empty placeholder_ (with no components in it)
        may not be editable in the Sitecore Experience Editor. In this example, because of the use
        of flexbox by the bootstrap columns, adding a bare <div> for the selectable empty placeholder
        results in it being hidden as it does not have a column class.

        Using the renderEmpty template allows us to customize the rendering of an empty placeholder
        and place it within a column div so that we can select it correctly.
      -->
    <ng-template renderEmpty let-renderings="renderings">
      <div class="col-sm">
        <!--
            The empty placeholder is rendered with another sc-placeholder, but using the
            renderings (plural) input instead of rendering. In this mode, it accepts a
            raw component data array, and name is unnecessary.
          -->
        <sc-placeholder [renderings]="renderings"></sc-placeholder>
      </div>
    </ng-template>
  </div>
</app-styleguide-specimen>
